import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from '@bingads-webui-react/fabric-control';
import classNames from 'classnames';
import { withCustomRendering } from '../custom-component';


const dataStyles = mergeStyles({
  paddingLeft: 8,
  paddingTop: 10,
  paddingBottom: 10,
  overflow: 'hidden',
  width: 716,
  whiteSpace: 'nowrap',
});

const PropertyData = ({ children }) =>
  (
    <div className={classNames('property-data', dataStyles)}>
      {children}
    </div>
  );

PropertyData.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

const PropertyDataWrapped = withCustomRendering(PropertyData);

export { PropertyDataWrapped as PropertyData };
